import { memo, useCallback, useEffect, useState } from 'react';
import { cn } from '@divlab/divanui';

import * as ModalWindows from '@Stores/ModalWindows';
import useMedias from '@Hooks/useMedias';
import useTranslation from '@Queries/useTranslation';
import Dropdown from '../Dropdown';
import GroupsPopup from '../GroupsPopup';
import styles from './Labels.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { FilterView } from '@Types/Filters';
import type { GroupData } from '@Components/Filters/typings';

export interface LabelsProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  groups?: GroupData[];
  filterView?: FilterView;
}

type ModalName = 'groups';

const Labels: FC<LabelsProps> = (props) => {
  const { groups, filterView, className } = props;
  const [openedGroups, setOpenedGroups] = useState(false);
  const [openedOptions, setOpenedOptions] = useState(false);
  const [modalOpened, setModalOpened] = useState(false);
  const { isMobileM } = useMedias();
  const { t } = useTranslation();

  const handleCloseModal = useCallback((modalName: ModalName) => {
    if (modalName === 'groups') {
      setOpenedGroups(false);
    } else {
      setOpenedOptions(false);
    }
    setModalOpened(false);
  }, []);

  const handleOpenGroups = useCallback(() => {
    if (openedOptions) {
      setOpenedOptions(false);
    }
    setTimeout(() => {
      setOpenedGroups(true);
    }, 100);

    if (!isMobileM) return;

    if (groups?.length > 0)
      return ModalWindows.open('MobileGroups', {
        label: 'Смотреть товары по группам',
        groups,
        onClose: () => {
          handleCloseModal('groups');
        },
      });
    setModalOpened(true);
  }, [groups, handleCloseModal, isMobileM, openedOptions]);

  useEffect(() => {
    if (isMobileM && openedGroups && groups?.length > 0) {
      ModalWindows.open('MobileGroups', {
        label: 'Смотреть товары по группам',
        groups,
        onClose: () => {
          handleCloseModal('groups');
        },
      });
      setModalOpened(true);
    }

    if (!isMobileM && modalOpened) {
      ModalWindows.close('MobileGroups');
      setModalOpened(false);
    }
  }, [groups, handleCloseModal, isMobileM, modalOpened, openedGroups]);

  return (
    <div className={cn(styles.labels, className)}>
      {groups?.length > 0 && (
        <Dropdown
          className={styles.label}
          label={t('ui.filters.sort-groups')}
          opened={openedGroups}
          popupWidth={740}
          onOpen={handleOpenGroups}
          onClose={() => setOpenedGroups(false)}
        >
          {!isMobileM && (
            <GroupsPopup
              label={t('ui.filters.sort-groups')}
              groups={groups}
              filterView={filterView}
            />
          )}
        </Dropdown>
      )}
    </div>
  );
};

export default memo(Labels);
